/*
 * File: /src/stores/shop-customobjectsgroups-list.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 23rd August 2018 11:42:46 am
 * Last Modified: Friday, 24th August 2018 5:03:43 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
const initialState = () => ({
    scope: 'customobjectsgroups',
})

const state = initialState()


const actions = {
    async GET_CUSTOM_OBJECTS({state, commit, dispatch}, { groupId }) {
        let params = {
            endpoint: `metafields/schema/${state.scope}/${groupId}`
        }
        
        try {
            const { metafield } = await dispatch(
                'shopifyApi/REQUEST', 
                params,
                { root: true }
            )

            if (metafield) {
                let value = JSON.parse(metafield.value)
                
                if (value && value.customObjects && value.customObjects.objects) {
                    let mappedCustomObjectKeys = value.customObjects.objects.map((item) => {
                        item.key = `${process.env.META_NAMESPACE}_${metafield.key}${item.key}`
                        return item
                    })
                    return { groupKey: metafield.key, customObjects: mappedCustomObjectKeys }
                }
            }


            return { groupKey: null, customObjects: null}
        } catch (error) {
            console.error(`GET_SCHEMA_METAFIELD_${state.scope}`, error)
            throw error
        }
    }
}

const mutations = {}

const getters = {}

export default {
    namespaced: true,
    state, actions, mutations, getters
}


// WEBPACK FOOTER //
// ./src/stores/shop-customobjects-list.js